import React from 'react';

import propTypes from 'prop-types';
import PriceSpan from 'common/components/formatters/PriceSpan';

export default class GalleryCartSummary extends React.Component {
  static propTypes = {
    pendingPrice: propTypes.number.isRequired,
  };

  render() {
    const { pendingPrice } = this.props;
    return (
      <div className="GalleryCartSummary">
        <span className="GalleryCartSummary__price">
          <PriceSpan amount={pendingPrice} />
        </span>
      </div>
    );
  }
}
